import { Component, OnInit, Input, Output } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { Quiz } from '../../models/quiz';
import { UserQuestionAnswer } from '../../models/userQuestionAnswer';
import { forkJoin, Subject } from '../../../../node_modules/rxjs';
import { QuizQuestion } from '../../models/quizQuestion';
import { AccountService } from '../../services/account.service';
import { Course } from '../../models/course';
import { FileService } from '../../services/file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {
  @Input('quizId') quizId;
  @Input('course') course: Course;
  @Output('exit') exit: Subject<boolean> = new Subject<boolean>();
  public quizLoaded: boolean = false;
  public quiz:Quiz;
  public userQuestionAnswers: UserQuestionAnswer[] = [];
  public activeQuestion:QuizQuestion;
  public activeQuestionAnswer:UserQuestionAnswer;
  public selectedAnswerId:number;

  public questionIndex:number = 0;
  private questionIndexCount:number = 0;

  public numberOfQuestions:number;
  public progress:number;
  public quizComplete:boolean = false;
  public correctCount: number = 0;
  public quizpercent: number=0;
  public downloadingCertificate: boolean = false;
  @Output('quizSuccessful') quizSuccessful = new Subject<boolean>();

  constructor(private courseService: CourseService, private accountService: AccountService, private fileService: FileService) { }

  ngOnInit() {

    forkJoin(this.courseService.getUserQuizAnswers(this.quizId), this.courseService.getQuiz(this.quizId)).subscribe(data=>{
      this.userQuestionAnswers = data[0];

      this.quiz = data[1];
      this.fixQuizQuestionImages();
      this.questionIndexCount = this.quiz.questions.length-1;
      this.numberOfQuestions = this.quiz.questions.length;
      this.setQuestion(0);
      this.quizLoaded = true;
    })
  }

  shuffleArray(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  fixQuizQuestionImages(){
    this.quiz.questions.forEach((q, i)=>{
      if(q.question_image) this.quiz.questions[i].question_image=environment.apiEndpoint+'/storage/quiz/'+q.question_image;
      this.quiz.questions[i].answers=this.shuffleArray(this.quiz.questions[i].answers);
    });
  }

  setUserQuestionAnswers(){
    this.courseService.getUserQuizAnswers(this.quizId).subscribe(res=>{
      this.userQuestionAnswers = res;
      if(this.questionIndex!=this.questionIndexCount){
        this.selectedAnswerId = null;
        this.setQuestion(this.questionIndex+1);
      }
      else{
        this.processAnswers();
        this.progress = 100;
        this.quizComplete = true;
        this.quizpercent=Math.floor((this.correctCount / this.quiz.questions.length)*100);
      }
    })
  }

  calcProgress(){
    this.progress=Math.ceil((100/this.numberOfQuestions)*this.questionIndex);
  }

  getUserQuestionAnswer(question_id): UserQuestionAnswer{
    let userQuestionAnswer= this.userQuestionAnswers.filter(answer=>{
      return answer.question_id == question_id;
    })[0];


    if(!userQuestionAnswer){
      userQuestionAnswer = new UserQuestionAnswer();
      userQuestionAnswer.quiz_id = this.quizId;
      userQuestionAnswer.user_id = this.accountService.getLocalAccount().id;
      userQuestionAnswer.question_id = question_id;
    }
    return userQuestionAnswer;
  }

  setQuestion(question_index){
    this.questionIndex = question_index;
    this.activeQuestion = this.quiz.questions[this.questionIndex];
    this.activeQuestionAnswer = this.getUserQuestionAnswer(this.activeQuestion.id);
    this.selectedAnswerId = this.activeQuestionAnswer.answer_id || null;
    this.calcProgress();
  }

  quit(){
    this.exit.next(true);
  }

  restart(){
    this.setQuestion(0);
    this.quizComplete=false;
  }

  setRadioAnswer(answer_id){
    this.selectedAnswerId = answer_id;
  }

  processAnswers(){
    this.correctCount=0;
    console.log(this.userQuestionAnswers);
    this.quiz.questions.forEach(question=>{
      let userAnswer=this.userQuestionAnswers.filter(ua=>{
        return ua.question_id==question.id && ua.answer_id==question.answer_id;
      })
      console.log('UserAnswer: ', userAnswer);
      if(userAnswer.length){
        // console.log('here', this.correctCount);
        this.correctCount++;
        // console.log('here', this.correctCount);
      }
    })
    let passmark=0.5;
    let usermark=(this.correctCount / this.numberOfQuestions);
    console.log(this.correctCount, this.numberOfQuestions, usermark, passmark);
    if(usermark >=passmark){
      this.accountService.getMyAccount().subscribe(res=>{
        this.accountService.setLocalAccount(res);
        if(this.correctCount>=(this.quiz.questions.length/2)){
          this.quizSuccessful.next(true);
        }
      })
    }
  }


  next(){
      let answer = this.getUserQuestionAnswer(this.activeQuestion.id);
      answer.answer_id = this.selectedAnswerId;


      this.courseService.postQuizQuestionAnswer(answer, this.course.id).subscribe(res=>{
        this.setUserQuestionAnswers();

      })

  }

  previous(){

    if(this.questionIndex!=0){
      this.setQuestion(this.questionIndex-1);
    }
  }

  downloadCertificate(){
    this.downloadingCertificate = true;
    this.fileService.downloadFile(`/api/course/certificate/${this.course.id}`).subscribe(data=>{
      let url = window.URL.createObjectURL(data);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download ='certificate.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.downloadingCertificate = false;
    })
  }

}
